import { GET_CORPORATE_CLIENTS_FAILURE, GET_CORPORATE_CLIENTS_REQUEST, GET_CORPORATE_CLIENTS_SUCCESS, GetCorporateClientsActionTypes, GetCorporateClientsState } from './types';

const defaultState: GetCorporateClientsState = {
  isLoading: false,
  errorMessage: "",
};

export default function getCorporateClients(state = defaultState, action: GetCorporateClientsActionTypes): GetCorporateClientsState {
  switch (action.type) {
    case GET_CORPORATE_CLIENTS_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case GET_CORPORATE_CLIENTS_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case GET_CORPORATE_CLIENTS_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};
